import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import aulasImg from '../../../assets/CasadoPandeiro_aulasregulares.jpeg';
import { Aula } from '../../../domain/entities/Aula';
import { GetAulasUseCase } from '../../../application/use-cases/GetAulasUseCase';
import { GoogleSheetsAulaRepositoryImpl } from '../../../infrastructure/repositories/GoogleSheetsAulaRepositoryImpl';
import { AulaCard } from '../../components/AulaCard/AulaCard';

export const AulasPage: React.FC = () => {
  const [aulas, setAulas] = useState<Aula[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const aulaRepository = new GoogleSheetsAulaRepositoryImpl();
        const getAulasUseCase = new GetAulasUseCase(aulaRepository);
        const aulasData = await getAulasUseCase.execute();
        setAulas(aulasData);
      } catch (error) {
        console.error('Erro ao carregar aulas:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${aulasImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
        role="img"
        aria-label="Aulas Regulares na Casa do Pandeiro"
      >
        <div className="container py-40 md:py-56" />
      </div>

      <div className="container pt-8 pb-16 md:pt-12 md:pb-20 max-w-3xl mx-auto">
      <h1 className="text-3xl md:text-4xl text-primary mb-3">Aulas Regulares</h1>
      <p className="text-muted-foreground mb-10">Turmas de pandeiro que rolam toda semana com diferentes professores.</p>

      {loading ? (
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      ) : (
        <div className="space-y-8">
          {aulas.length > 0 ? (
            <div>
              <h2 className="text-xl text-primary mb-4">Aulas de Pandeiro</h2>
              <div className="space-y-4">
                {aulas.map((aula) => (
                  <AulaCard
                    key={aula.id.value}
                    instructor={aula.instructor.value}
                    day={aula.day.value}
                    url={aula.url.value}
                    instagram={aula.instagram.value}
                  />
                ))}
              </div>
            </div>
          ) : (
            <p className="text-muted-foreground text-sm">Nenhuma aula disponível no momento.</p>
          )}
        </div>
      )}

      <div className="mt-12 text-center p-8 bg-secondary/60 rounded-lg">
        <p className="text-foreground mb-4">Quer informações ou inscrição?</p>
        <Link
          to="/contato"
          className="inline-flex items-center justify-center px-8 py-3 rounded-lg bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity"
        >
          Entre em contato
        </Link>
      </div>
    </div>
    </>
  );
};
